import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Shield } from 'lucide-react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('applydrive_cookie_consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('applydrive_cookie_consent', 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 bg-slate-900 border-t border-slate-700 shadow-2xl"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-4">
        <Shield className="w-5 h-5 text-[#00a94f] flex-shrink-0" />
        <p className="text-sm text-slate-300 text-center sm:text-left flex-1">
          This application uses only essential cookies required for the form to function. No tracking or advertising cookies are used. 
          By continuing, you accept our{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-[#00a94f] hover:underline">Privacy Policy</a>.
        </p>
        <Button
          onClick={handleAccept}
          className="bg-[#00a94f] hover:bg-[#008c42] text-white text-sm px-6 py-2 rounded-lg flex-shrink-0"
          data-testid="cookie-accept-btn"
        >
          Accept
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
